import { Edit, SummaryBrand } from "src/types/graphql.d";

export enum CarouselType {
  Edit = "edit",
  Brand = "brand",
}

export type CarouselItem = Edit | SummaryBrand;
